import { useCallback, useState } from "react"
import { SubformProps, ConsumerAppFormData } from "."
import { MustClickLink } from "../../components"
import api from "../../api-client"
import { toast } from "react-toastify"
import { useAppState } from "../../hooks"
import { AwaitingContractLanguage } from "./awaiting-contract"
import { lappToFormData } from "./util"
import { SubmitLoanApplication } from "./submit-loan-application"

// type ContractDocProps = {
//   formData: ConsumerAppFormData
//   onClicked: () => void
//   clicked: boolean
// }

// const ContractDoc = ({ formData, onClicked, clicked }: ContractDocProps) => {
//   const [loading, setLoading] = useState(false)
//   const suffix = `${encodeURIComponent('solar_contract')}/${encodeURIComponent('Signed Contract')}`
//   const path = `/loanapps/${formData.lookup}/docs/${suffix}`

//   const download = useCallback(ev => {
//     ev.preventDefault()
//     setLoading(true)
//     api.authenticatedFetch(path, {
//       responseType: 'blob'
//     }).then(async res => {
//       const blob = await res.blob()
//       // open inline if possible rather than downloading
//       window.open(URL.createObjectURL(blob), '_blank')
//       onClicked()
//     }).catch(ex => toast.error(ex.error, { autoClose: false }))
//       .finally(() => setLoading(false))
//   }, [])

//   return <div className="mt-4">
//     <div>
//       <p>
//         Your installer has uploaded the following installation contract. Please review it
//         carefully to confirm the following details.
//       </p>

//       <ul className="mt-2">
//         <li>
//           The contract is authorized by you and reflects your intention to
//           proceed with the improvements as described therein
//         </li>
//         <li>The details of the contract match the amounts from the Project Details section</li>
//       </ul>
//     </div>
//     <MustClickLink
//       label="Installation Contract"
//       onClicked={ev => {
//         download(ev)
//       }}
//       clicked={clicked}
//       loading={loading}
//     />
//   </div>
// }


export const ReviewContract = ({ formData, update, onSubmit }: Partial<SubformProps>) => {
  const { tenant } = useAppState()
  // const [contractClicked, setContractClicked] = useState(false)

  if (!formData.contractDoc) {
    return <div>
      <h2>Last Step</h2>
      <p>
        You should have received a documents package from {tenant.config.bankEmail} that
        includes the documents necessary to proceed with your loan.
      </p>
      <AwaitingContractLanguage />
      <button
        type="button"
        className="btn btn-primary"
        onClick={async () => {
          const { lapp } = await api.get(`/c/loanapps/${formData.lookup}`)
          update(lappToFormData(lapp))
          toast.info('Checking for updates... once a contract has been uploaded, you will be prompted to submit your loan application.')
        }}
      >Check for Updates</button>
    </div>
  }

  return <div>
    <h2>Submit Loan Application</h2>

    <p>
      Your installer has submitted the final details for your project. Please review
      these details carefully. If anything is incorrect, work with your installer to
      request additional changes.
    </p>

    {/* <h5>Installation Contract</h5>
    <ContractDoc
      formData={formData}
      onClicked={() => setContractClicked(true)}
      clicked={contractClicked}
    /> */}

    <SubmitLoanApplication
      formData={formData}
      onSubmit={onSubmit}
      update={update}
    />

  </div>
}

export default ReviewContract